import { Toast } from 'vant'

// 降级兼容方案
function fallbackCopy (text) {
  const textArea = document.createElement('textarea')
  textArea.value = text
  textArea.style.position = 'fixed'
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.width = '2em'
  textArea.style.height = '2em'
  textArea.style.padding = '0'
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'
  textArea.style.background = 'transparent'
  textArea.style.opacity = '0'

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')
    if (successful) {
      Toast.success('复制成功')
    } else {
      Toast.fail('复制失败，请长按复制')
    }
  } catch (err) {
    console.error('兼容方案复制失败:', err)
    Toast.fail('复制失败，请长按复制')
  }
  document.body.removeChild(textArea)
  document.activeElement.blur()
}

// 导出主函数
export function copyText (text) {
  if (!text) return
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(() => {
      Toast.success('复制成功')
    }).catch(() => {
      fallbackCopy(text)
    })
  } else {
    fallbackCopy(text)
  }
}
